(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clearance-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  const SFCLR_ENDPOINT = "https://script.google.com/macros/s/AKfycbyahk96BdFI0vpv_AvYYAlisfe6ufwLLckSOzgz9jxHhJVMSORKo9xgqlco0q_GXqqe/exec";

  function initRoot(root) {
    if (root.dataset.sfclrInit === 'true') return;
    root.dataset.sfclrInit = 'true';

    const modal = root.querySelector('[data-sfclr-modal]');
    if (!modal) return;

    const formWrap = modal.querySelector('[data-sfclr-form-wrap]');
    const form = modal.querySelector('[data-sfclr-form]');
    const done = modal.querySelector('[data-sfclr-done]');
    const errorEl = modal.querySelector('[data-sfclr-error]');
    const productEl = modal.querySelector('[data-sfclr-product]');
    const variantEl = modal.querySelector('[data-sfclr-variant]');
    const thumbEl = modal.querySelector('[data-sfclr-thumb]');
    const skuInput = modal.querySelector('[data-sfclr-sku]');
    const variantIdInput = modal.querySelector('[data-sfclr-variant-id]');
    const headingEl = modal.querySelector('.sfclr-modal__heading');
    const submitBtn = form && form.querySelector('.sfclr-modal__submit');
    let lastTrigger = null;
    let lastImage = '';

    function setError(message) {
      if (!errorEl) return;
      if (message) {
        errorEl.hidden = false;
        errorEl.textContent = message;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function showForm() {
      if (formWrap) formWrap.hidden = false;
      if (done) done.hidden = true;
      if (headingEl) headingEl.textContent = 'Request clearance pricing';
      setError('');
      if (submitBtn) submitBtn.disabled = false;
    }

    function showDone() {
      if (headingEl) headingEl.textContent = 'Request sent';
      if (formWrap) formWrap.hidden = true;
      if (done) done.hidden = false;
    }

    function openModal(btn) {
      lastTrigger = btn;
      lastImage = btn.getAttribute('data-variant-image') || '';
      if (productEl) productEl.textContent = btn.getAttribute('data-product-title') || '';
      if (variantEl) variantEl.textContent = btn.getAttribute('data-variant-title') || '';
      if (skuInput) skuInput.value = btn.getAttribute('data-variant-sku') || '';
      if (variantIdInput) variantIdInput.value = btn.getAttribute('data-variant-id') || '';
      if (thumbEl) {
        if (lastImage) {
          thumbEl.src = lastImage;
          thumbEl.alt = btn.getAttribute('data-product-title') || '';
          thumbEl.hidden = false;
        } else {
          thumbEl.removeAttribute('src');
          thumbEl.alt = '';
          thumbEl.hidden = true;
        }
      }
      if (form) {
        if (form.elements.phone) form.elements.phone.value = '';
        if (form.elements.notes) form.elements.notes.value = '';
      }
      showForm();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const phone = form && form.elements.phone;
      if (phone) phone.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      showForm();
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
      lastImage = '';
    }

    root.addEventListener('click', function (e) {
      const btn = e.target.closest('.sfclr-card__request');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(btn);
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-sfclr-dismiss]')) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        e.preventDefault();
        closeModal();
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        setError('');
        if (submitBtn) submitBtn.disabled = true;

        const payload = {
          product: productEl ? productEl.textContent : '',
          variant: variantEl ? variantEl.textContent : '',
          sku: skuInput ? skuInput.value : '',
          email: form.elements.email ? form.elements.email.value : '',
          company: form.elements.company ? form.elements.company.value : '',
          phone: form.elements.phone ? form.elements.phone.value : '',
          notes: form.elements.notes ? form.elements.notes.value : ''
        };

        fetch(SFCLR_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        })
          .then(function () { showDone(); })
          .catch(function () {
            setError('Something went wrong. Please contact your rep directly.');
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }
  }

  function fillNav() {
    var nav = document.querySelector('[data-sfclr-nav]');
    if (!nav) return;

    var list = nav.querySelector('[data-sfclr-nav-list]');
    if (!list) return;
    list.replaceChildren();

    var items = [];
    document.querySelectorAll('[data-sfclr-section]').forEach(function (el) {
      var heading = (el.getAttribute('data-sfclr-heading') || '').trim();
      var id = el.id || '';
      if (!heading || !id) return;
      items.push({ heading: heading, id: id });
    });

    if (items.length < 2) {
      nav.hidden = true;
      return;
    }

    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'sfclr-nav__item';

      var link = document.createElement('a');
      link.className = 'sfclr-nav__link';
      link.href = '#' + item.id;
      link.textContent = item.heading;
      link.setAttribute('data-sfclr-nav-link', item.id);
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(item.id);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });

      li.appendChild(link);
      list.appendChild(li);
    });

    nav.hidden = false;
  }

  function sfclrInit() {
    document.querySelectorAll('[data-sfclr]').forEach(initRoot);
    fillNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sfclrInit);
  } else {
    sfclrInit();
  }

  document.addEventListener('shopify:section:load', sfclrInit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const REGISTRY = new WeakMap();

  class HeroCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-hero-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
      this.count = this.slides.length;
      this.dwell = parseInt(root.dataset.dwell, 10) || 5000;
      this.transition = parseInt(root.dataset.transition, 10) || 600;
      this.autoplayOn = root.dataset.autoplay === 'true' && this.count > 1;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      this.pauseBtn = root.querySelector('[data-hero-pause]');
      this.index = 0;
      this.animating = false;
      this.animTimer = null;
      this.paused = false;

      if (this.count > 1) this.buildClones();
      this.bind();
      this.setPosition(this.index, false);
      this.updateDots();
      if (this.autoplayOn && !this.reduce) this.start();
    }

    buildClones() {
      const first = this.slides[0].cloneNode(true);
      const last = this.slides[this.count - 1].cloneNode(true);
      [first, last].forEach((c) => {
        c.classList.add('is-clone');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
      });
      this.track.appendChild(first);
      this.track.insertBefore(last, this.slides[0]);
      this.index = 1;
    }

    setPosition(i, animate) {
      this.track.style.transition = animate && !this.reduce ? 'transform ' + this.transition + 'ms ease' : 'none';
      this.track.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (!animate) { void this.track.offsetHeight; }
    }

    go(i) {
      if (this.count <= 1 || this.animating) return;
      this.animating = true;
      this.index = i;
      this.setPosition(this.index, true);
      this.updateDots();
      // Release the lock on transitionend/transitioncancel OR this fallback, whichever
      // fires first. Covers cancelled transitions (which emit transitioncancel, not
      // transitionend) AND the reduced-motion / transition:none case where no transition
      // event ever fires. Under reduced motion the effective duration is 0, so the
      // fallback fires on the next tick and the carousel never locks. finishTransition()
      // is idempotent and clears this timer, so end/cancel/timeout never double-fire.
      if (this.animTimer) { clearTimeout(this.animTimer); this.animTimer = null; }
      var fallback = (this.reduce ? 0 : this.transition) + 50;
      this.animTimer = setTimeout(() => this.finishTransition(), fallback);
    }
    next() { this.go(this.index + 1); }
    prev() { this.go(this.index - 1); }

    // Single, idempotent end-of-transition path. Whichever of transitionend,
    // transitioncancel, or the go() fallback timeout arrives first wins; the rest no-op.
    finishTransition() {
      if (!this.animating) return;
      if (this.animTimer) { clearTimeout(this.animTimer); this.animTimer = null; }
      // Clone snap at the loop edges. Runs while animating is still true and is fully
      // synchronous (setPosition disables the transition, sets the transform, then forces
      // a reflow), so no click can land mid-snap — the lock only lifts afterwards.
      if (this.index === this.count + 1) { this.index = 1; this.setPosition(1, false); }
      else if (this.index === 0) { this.index = this.count; this.setPosition(this.count, false); }
      this.animating = false;
      this.applyControlColors();
    }

    realIndex() {
      if (this.count <= 1) return 0;
      let r = (this.index - 1) % this.count;
      if (r < 0) r += this.count;
      return r;
    }
    updateDots() {
      const active = this.realIndex();
      if (this.dots.length) this.dots.forEach((d, i) => {
        const on = i === active;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      this.setSlideVisibility(active);
      this.applyControlColors(active);
    }
    // Keep off-screen slides out of the accessibility tree and tab order. Only the active
    // slide is exposed; every other (non-clone) slide is aria-hidden + inert, so screen
    // readers skip its headline/CTA and keyboard focus can't land on a button behind the
    // scenes. Clones are left exactly as buildClones() set them (aria-hidden + tabindex -1).
    setSlideVisibility(active) {
      const idx = (active == null) ? this.realIndex() : active;
      this.slides.forEach((s, i) => {
        if (i === idx) {
          s.removeAttribute('aria-hidden');
          s.removeAttribute('inert');
        } else {
          s.setAttribute('aria-hidden', 'true');
          s.setAttribute('inert', '');
        }
      });
    }
    goToReal(realIdx) { this.go(realIdx + 1); }

    applyControlColors(real) {
      const idx = (real == null) ? this.realIndex() : real;
      const s = this.slides[idx];
      if (!s) return;
      const set = (prop, val) => { if (val != null && val !== '') this.root.style.setProperty(prop, val); };
      set('--arrow-color', s.dataset.arrowColor);
      set('--dot-color', s.dataset.dotColor);
      set('--btn-fill', s.dataset.btnFill);
      set('--btn-ink', s.dataset.btnInk);
      set('--btn-plate-rest', s.dataset.btnPlateRest);
    }

    start() { this.stop(); if (this.autoplayOn && !this.reduce) { this.timer = setInterval(() => this.next(), this.dwell); } this.paused = false; this.updatePauseBtn(); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    pause() { this.stop(); this.paused = true; this.updatePauseBtn(); }
    resume() { if (this.autoplayOn && !this.reduce && !this.paused) this.start(); }
    togglePause() { this.paused ? (this.paused = false, this.start()) : this.pause(); }
    updatePauseBtn() {
      if (!this.pauseBtn) return;
      const icon = this.pauseBtn.querySelector('.hero-pause-icon');
      this.pauseBtn.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      if (icon) icon.textContent = this.paused ? '▶' : '❚❚';
    }

    restartDwell() { if (this.autoplayOn && !this.reduce && !this.paused) this.start(); }

    bind() {
      // Only the track's own 'transform' transition may clear the lock. Child element
      // transitions (headline, subhead, button) bubble to the track too and must be
      // ignored. transitioncancel is handled alongside transitionend: when a transform is
      // interrupted the browser fires cancel, NOT end, and either must release the lock.
      const onTransitionSettle = (e) => {
        if (e.propertyName === 'transform' && e.target === this.track) this.finishTransition();
      };
      this.track.addEventListener('transitionend', onTransitionSettle);
      this.track.addEventListener('transitioncancel', onTransitionSettle);

      const prev = this.root.querySelector('[data-hero-prev]');
      const next = this.root.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', () => { this.prev(); this.restartDwell(); });
      if (next) next.addEventListener('click', () => { this.next(); this.restartDwell(); });
      this.dots.forEach((d) => d.addEventListener('click', () => { this.goToReal(parseInt(d.dataset.heroDot, 10)); this.restartDwell(); }));
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.togglePause());

      this.root.addEventListener('mouseenter', () => { if (!this.paused) this.stop(); });
      this.root.addEventListener('mouseleave', () => { if (!this.paused) this.resume(); });
      this.root.addEventListener('focusin', () => { if (!this.paused) this.stop(); });
      this.root.addEventListener('focusout', () => { if (!this.paused && !this.root.contains(document.activeElement)) this.resume(); });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else if (!this.paused) this.resume();
      });

      const vp = this.root.querySelector('.hero-viewport');
      if (vp) vp.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.prev(); this.restartDwell(); }
        if (e.key === 'ArrowRight') { this.next(); this.restartDwell(); }
      });

      let startX = 0, dx = 0, touching = false;
      this.track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; touching = true; this.stop(); }, { passive: true });
      this.track.addEventListener('touchmove', (e) => { if (touching) dx = e.touches[0].clientX - startX; }, { passive: true });
      this.track.addEventListener('touchend', () => {
        if (Math.abs(dx) > 40) { dx < 0 ? this.next() : this.prev(); }
        touching = false; dx = 0; this.restartDwell();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-hero-carousel]').forEach((el) => {
      if (el.dataset.heroInit === 'true') return;
      el.dataset.heroInit = 'true';
      REGISTRY.set(el, new HeroCarousel(el));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-hero-carousel]');
    if (!root) return;
    const inst = REGISTRY.get(root);
    if (!inst) return;
    inst.pause();
    const idx = inst.slides.indexOf(e.target);
    if (idx >= 0) inst.go(idx + 1);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const root = e.target.closest('[data-hero-carousel]');
    const inst = root && REGISTRY.get(root);
    if (inst) { inst.paused = false; inst.resume(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
